import { Grid, Box, Divider, IconButton, styled } from '@mui/material'
import AdaptativeGridContainer from '../../components/shared/AdaptativeGridContainer'
import React, { useEffect, useState, useContext } from 'react'
import DefaultPainel from '../../components/shared/Painel'
import FormReserva from '../../components/forms/Reserva'
import Dater from '../../services/DateFormat'
import TableHeader from '../../components/shared/tables/TableHeader'
import FilterButton from '../../components/buttons/FilterButton'
import { Add, DeleteForever } from '@mui/icons-material'
import BasicModal from '../../components/shared/modals/BaseModal'
import gerarPaginacao from '../../services/pagination'
import { Obras, Reservas } from '../../services/http'
import PrivateRC from '../../components/PrivateRC'
import { confirmDelete } from '../livros/functions'
import { PermissionsContext } from '../../providers/permissions'
import SmallTextField from '../../components/textfield/SmallTextfield'
import getUser from '../../services/http/user/getUser'
import BasicDatagrid from '../../components/shared/tables/BasicDatagrid'
import SearchStartAdornment from '../../components/adornment/SearchStartAdornment'
import SearchEndAdornment from '../../components/adornment/SearchEndAdornment'
import MobileFilterHeaderContainer from '../../components/filters/MobileFilterHeaderContainer'

const OpenButton = ({ ...props }) => (
  <FilterButton
    color="white"
    Icon={Add}
    {...props}
    text="Nova reserva"
    bg="#000000BF"
  />
)

const ReservationTable = styled(BasicDatagrid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    height: '71.5vh'
  },
  [theme.breakpoints.up('lg')]: {
    height: '71.5vh'
  },
  [theme.breakpoints.up('xl')]: {
    height: '76vh'
  },
  '& .MuiDataGrid-cell': {
    textAlign: 'start',
    justifyContent: 'normal'
  }
}))

const Reserva = () => {
  const { hasThisPermission, permissions } = useContext(PermissionsContext)

  const [books, setBooks] = useState([])
  const getBooks = async () => {
    const { data } = await Obras().show({ per_page: -1 })
    setBooks(data.data)
  }
  const [rows, setRows] = useState([])
  const [queryLector, setQueryLector] = useState([])
  const [query, setQuery] = useState({})
  const [tloading, setTloading] = useState(false)

  const [lastPage, setLastPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)

  const baseColumn = {
    headerClassName: 'styledHeader',
    sortable: false
  }

  let typingTimer = ''

  const getLector = () => {
    setQuery(
      Object.assign(query, {
        'includes[leitor.user][name]': `%${queryLector?.toUpperCase()}%`
      })
    )
    getReservas(query)
  }

  const handleClean = () => {
    if (queryLector !== '') {
      setQueryLector('')
      delete query.titulo
      getReservas({ ...query, 'includes[leitor.user][name]': undefined })
    }
  }

  const deleteReserva = async id => {
    await Reservas(id).delete(
      {},
      { notification: true, message: 'Sucesso ao remover reserva!' }
    )
    getReservas(query, currentPage)
  }
  const columns = [
    {
      field: 'biblioteca',
      headerName: 'Biblioteca',
      flex: 1
    },
    {
      field: 'leitor',
      headerName: 'Leitor',
      flex: 2,
      ...baseColumn
    },
    {
      field: 'livro',
      headerName: 'Livro',
      flex: 4,
      ...baseColumn
    },
    {
      field: 'reserva',
      headerName: 'Data da Reserva',
      flex: 2,
      ...baseColumn
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      ...baseColumn
    },
    hasThisPermission({ permission: 'reservas#delete' })
      ? {
          field: 'actions',
          headerName: 'Ações',
          flex: 1,
          renderCell: ({ row }) => (
            <PrivateRC permission="reservas#delete">
              <IconButton
                onClick={() => {
                  const msg = `Deseja remover esta reserva?`
                  confirmDelete(row.id, 'reserva', msg, deleteReserva)
                }}
                color="error"
              >
                <DeleteForever />
              </IconButton>
            </PrivateRC>
          )
        }
      : {}
  ]

  const getReservas = async (filters = {}, page = 1) => {
    const user = await getUser()
    let userFilter = {}
    if (permissions.roles.length < 2) {
      userFilter = { 'includes[leitor][user_id]': user.id }
    }
    setTloading(true)
    const { data } = await Reservas().show({
      page,
      ...filters,
      ...userFilter,
      'includes[]': 'obra,leitor.user,leitor.biblioteca,statusReserva'
    })
    setLastPage(data.last_page)
    setCurrentPage(data.current_page)

    const aux = data.data.map(item => ({
      ...item,
      leitor: item.leitor.user.name,
      reserva: Dater().formatar(item.updated_at, 'dd/mm/yyyy'),
      biblioteca: item.leitor.biblioteca.apelido,
      livro: item.obra.titulo,
      status: item.status_reserva.descricao
    }))
    setRows(aux)
    setTloading(false)
  }

  const init = async () => {
    await getReservas()
    await getBooks()
  }

  useEffect(() => {
    if (permissions !== null) {
      init()
    }
  }, [permissions])

  const pagination = gerarPaginacao(
    true,
    lastPage,
    currentPage,
    (event, value) => getReservas(query, value)
  )

  const [status, setStatus] = useState(false)

  return (
    <Box>
      <DefaultPainel sx={{ mt: '4vh' }}>
        <AdaptativeGridContainer>
          <>
            <TableHeader
              titulo="Lista de Reservas"
              controls={
                <MobileFilterHeaderContainer>
                  <PrivateRC roles="bibliotecario">
                    <SmallTextField
                      color="white"
                      type="text"
                      placeholder="Leitor"
                      variant="standard"
                      onKeyDown={() => {
                        clearTimeout(typingTimer)
                      }}
                      onKeyUp={() => {
                        clearTimeout(typingTimer)
                        typingTimer = setTimeout(getLector, 1000)
                      }}
                      onChange={({ target }) => {
                        setQueryLector(target.value)
                      }}
                      value={queryLector}
                      InputProps={{
                        style: { color: 'white' },
                        startAdornment: <SearchStartAdornment />,
                        endAdornment: (
                          <SearchEndAdornment action={() => handleClean()} />
                        )
                      }}
                    />
                  </PrivateRC>
                  <BasicModal
                    title="Nova Reserva"
                    Caller={OpenButton}
                    status={status}
                    closeEvent={event => {
                      setStatus(event)
                    }}
                    sx={{
                      minWidth: '32vw',
                      width: { xs: '100vw', md: '32vw' }
                    }}
                  >
                    <FormReserva
                      onSubmitEnd={() => {
                        getReservas(query)
                        setStatus(false)
                      }}
                      books={books}
                    />
                  </BasicModal>
                </MobileFilterHeaderContainer>
              }
            />

            <Grid item xs={12} sm={12}>
              <Divider />
              <ReservationTable
                rows={rows}
                columns={columns}
                disableColumnMenu
                loading={tloading}
                pagination={pagination}
              />
            </Grid>
          </>
        </AdaptativeGridContainer>
      </DefaultPainel>
    </Box>
  )
}

export default Reserva
